import React from 'react';
import { inputClasses, labelClasses } from './types';
import Button from '@/components/ui/Button';

const PasswordResetForm: React.FC<{
  newPassword: string;
  setNewPassword: (value: string) => void;
  resetError: string;
  resetSuccess: string;
  resetLoading: boolean;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
}> = ({
  newPassword,
  setNewPassword,
  resetError,
  resetSuccess,
  resetLoading,
  onSubmit,
  onCancel,
}) => (
  <form onSubmit={onSubmit} className="space-y-3">
    <div>
      <label htmlFor="reset-user-password" className={labelClasses}>New Password</label>
      <input
        id="reset-user-password"
        type="password"
        required
        minLength={6}
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        placeholder="Min 6 characters"
        className={inputClasses}
      />
    </div>
    {resetError && <div className="text-sm text-red-600 dark:text-red-400">{resetError}</div>}
    {resetSuccess && <div className="text-sm text-green-600 dark:text-green-400">{resetSuccess}</div>}
    <div className="flex gap-2">
      <Button
        type="submit"
        loading={resetLoading}
        loadingLabel="Updating password"
      >
        Update Password
      </Button>
      <button
        type="button"
        onClick={onCancel}
        className="px-3 py-1.5 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-md"
      >
        Cancel
      </button>
    </div>
  </form>
);

export default PasswordResetForm;
